'use strict';



export function uiRouterConfig ($urlServiceProvider) {
  'ngInject';

  const defaultState = 'external.insert-email';


  /**
   * UrlRulesApi.initial(handler: string | UrlRuleHandlerFn | TargetState | TargetStateDef, options?: object): void
   *
   * @see https://ui-router.github.io/ng1/docs/1.0.0/interfaces/url.urlrulesapi.html
   * Defines the initial state, path, or behavior to use when the app starts.
   *
   * This rule is triggered the first time the URL is checked (when the app initially loads).
   * The rule is triggered only when the url matches either "" or "/".
   * Note: The rule is intended to be used when the root of the application is directly linked to.
   * When the URL is not "" or "/" and doesn't match other rules, the otherwise rule is triggered.
   * This allows 404-like behavior when an unknown URL is deep-linked.
   */
  $urlServiceProvider.rules.initial({ state: defaultState });

}



// WEBPACK FOOTER //
// ./client/app/app.config/router.config.js